export default {
    form: {
        control_type: null,
        expiration_date: null,
        last_recharge_folios: 0,
        folioRecharge: 0,
        last_recharge_date: "",
        folios_consumed: 0,
        folios_consumed_reception: 0,
        folios_balance: 0,
        recharge_notice: 0,
        digital_signature_expiration: null
    }
};



// WEBPACK FOOTER //
// ./src/modules/electronic-invoicing-services/state.js